module.exports = __webpack_public_path__ + "img/menu_ladies_dermapen.6cbbba4b.png";